import React, { useState, useEffect } from 'react';
import {
    Card,
    CardBody,
    Button,
    Input,
    Row,
    Label
} from 'reactstrap';
import { Colxx, Separator } from '../../../../../../components/common/CustomBootstrap';

export default function HelpCenterExternalLink({
    botSettings,
    saveIntegration,
}) {
    const [externalLinks, setExternalLinks] = useState([{
        title: '',
        link: '',
    }])
    useEffect(() => {
        if (botSettings.externalLinks !== undefined && botSettings.externalLinks.length > 0) {
            let links = [];
            botSettings.externalLinks.map((m) =>
                links.push({
                    title: m.title,
                    link: m.link,
                }));
            setExternalLinks(links);
        }
    }, [botSettings]);

    const AddLinks = () => {
        let links = [...externalLinks];;
        links.push({
            title: '',
            link: '',
        });
        setExternalLinks(links);
    };

    const RemoveLinks = (index) => {
        const values = [...externalLinks];
        values.splice(index, 1);
        setExternalLinks(values);
    };

    const handleSave = () => {
        let setting = botSettings;
        setting.externalLinks = externalLinks;
        saveIntegration({
            botSetting: setting
        });
    };

    const handleChange = (e, index) => {
        const values = [...externalLinks];
        if (e.target.name === 'title') {
            values[index].title = e.target.value;
        }
        else if (e.target.name === 'link') {
            values[index].link = e.target.value;
        }
        setExternalLinks(values);
    }
    return (
        <Card className="mb-4">
            <CardBody>
                <div className="text-center">
                    <h6>External Link</h6>
                    <Separator className="mb-3" />
                    <div className='text-left'>
                        {externalLinks.length > 0 && externalLinks.map((m, i) => {
                            return (
                                <Row>
                                    <Colxx md={5} className='mt-2 text-left'>
                                        <Label>Title</Label>
                                        <Input
                                            type="text"
                                            value={m.title}
                                            onChange={(e) => handleChange(e, i)}
                                            name="title"
                                        />
                                    </Colxx>
                                    <Colxx md={6} className='mt-2 text-left'>
                                        <Label>Link</Label>
                                        <Input
                                            type="text"
                                            value={m.link}
                                            onChange={(e) => handleChange(e, i)}
                                            name="link"
                                        />
                                    </Colxx>
                                    <Colxx md={1} className='mt-2 pt-1 text-left'>
                                        {/* <Label>{" "} </Label> */}
                                        <Button
                                            className="mt-4"
                                            style={{ backGround: 'red' }}
                                            color="danger"
                                            size="xs"
                                            outline
                                            onClick={() => RemoveLinks(i)}
                                        >-</Button>
                                    </Colxx>
                                </Row>
                            );
                        })}
                        <Button className='text-left'
                            size="xs"
                            color="success"
                            outline
                            style={{ marginTop: '20px', display: 'inline-block' }}
                            onClick={AddLinks}
                        >
                            + Add Link
                        </Button>
                    </div>
                    <Separator className="mt-5" />

                    <Button
                        size="xs"
                        color="primary"
                        className="ml-2"

                        style={{ marginTop: '20px', display: 'inline-block' }}
                        onClick={() => handleSave()}
                    >
                        Save
                    </Button>
                </div>
            </CardBody>
        </Card>);
}